export default __webpack_public_path__ + "static/media/Version (2) - LOTR_05.3f85d735.jpg";